import { OlContact } from '../../lib/types/models/ol/ol-contact'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getOlOtherContacts(id: number) {
  return restApiClient
    .url(constructApiUrl(API.ols.getOlOtherContacts.url, { id }))
    .get<OlContact[]>()
}
